module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.params && _vm.params.isActive) ? _c('ModalDefault', {
    attrs: {
      "size": "s",
      "with-content": true,
      "theme": true,
      "fix-height": false,
      "fix-width": false,
      "loading": false
    },
    on: {
      "close": function($event) {
        _vm.close()
      }
    }
  }, [_c('template', {
    slot: "main"
  }, [_c('div', {
    staticClass: "row d-flex align-items-center"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.params.periodHasComponent.component.cpntName))]), _vm._v(" "), _c('p', {
    staticClass: "sap"
  }, [_vm._v("SAP : " + _vm._s(_vm.params.periodHasComponent.component.codeSap))]), _vm._v(" "), _c('p', {
    staticClass: "ean"
  }, [_vm._v("EAN : " + _vm._s(_vm.params.periodHasComponent.component.codeEan))])]), _vm._v(" "), (_vm.hasImg) ? _c('div', {
    staticClass: "col"
  }, [(_vm.params.periodHasComponent.component.cpntImd) ? _c('img', {
    staticStyle: {
      "max-height": "200px"
    },
    attrs: {
      "src": _vm.params.periodHasComponent.component.cpntImd
    }
  }) : _c('img', {
    staticStyle: {
      "max-height": "200px"
    },
    attrs: {
      "src": require("../../../../static/img/no_image.jpg")
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive mt-4"
  }, [_c('table', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t("catalogForecast.market.productHierarchyLabel")) + " 1")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.params.periodHasComponent.component.cateName1))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t("catalogForecast.market.productHierarchyLabel")) + " 2")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.params.periodHasComponent.component.cateName2))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t("catalogForecast.market.productHierarchyLabel")) + " 3")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.params.periodHasComponent.component.cateName3))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t("catalogForecast.market.productHierarchyLabel")) + " 4")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.params.periodHasComponent.component.cateName4))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t("catalogForecast.market.productHierarchyLabel")) + " 5")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.params.periodHasComponent.component.cateName5))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t("catalogForecast.market.typeLabel")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.params.periodHasComponent.component.type))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t("catalogForecast.market.statusLabel")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.params.periodHasComponent.component.statusName.toUpperCase()))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t("catalogForecast.market.labOfficeLabel")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getPropertyValue(_vm.params.periodHasComponent.component.labOffice)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t("catalogForecast.market.parentCodeLabel")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getPropertyValue(_vm.params.periodHasComponent.component.parentCode)))])])])])])], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-80861fec","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/catalogForcast/elements/ComponentInfos.vue
// module id = 3298
// module chunks = 0